import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from '../../../../Components/ComboBox'
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../utils/api'

import urls from '../../../../utils/urls'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CreateOperationForm({ setOperations, vehiculesTypes }) {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [classification, setClassification] = useState([{ label: 'new' }])
  const [tempCategory, settempCategory] = useState([])
  const [Category, setCategory] = useState([])
  const [SubCategory, setSubCategory] = useState([])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Date: '',
      Libelle: '',
      Classification: '',
      Category: '',
      SubCategory: '',
      Montant: '',
      Devise: '',
    },
  })

  const handleClickOpen = () => {
    setOpen(true)
    fetchCategoryFi()
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      Classification: data.Classification.label,
      Category: data.Category.label,
      SousCategorie: data.SubCategory.label,
      // TypeOperation: 'D',
    }

    const response = await makePostRequest(urls.crudBudgetOpertations, payload, {}, true)
    if (response.status === 201) {
      setOperations((operations) => ({
        ...operations,
        results: [...operations.results, response.data],
        count: operations.count + 1,
      }))
      handleClose()
    }
  }

  const fetchCategoryFi = async () => {
    const url = urls.fetchCategories + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      let ccheck = []
      let classifcation_list = []
      data.forEach((v) => {
        if (!ccheck.includes(v.Classification)) {
          ccheck.push(v.Classification)
          classifcation_list.push({ label: v.Classification, id: v.id })
        }
      })
      setClassification(classifcation_list)
      settempCategory(data)
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>{t('finance.monBudget.create')}</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('finance.monBudget.addOperationTitle')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              InputLabelProps={{ shrink: true }}
              rules={{ required: true }}
              name="Date"
              label={t('finance.common.date')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Libelle"
              label={t('finance.monBudget.columnLibelle')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Montant"
              label={t('finance.monBudget.columnAmount')}
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Classification', j)
                let check = []
                let check_list = []
                tempCategory.forEach((v) => {
                  if (j && v.Classification === j.label && !check.includes(v.Categorie)) {
                    check.push(v.Categorie)
                    check_list.push({ label: v.Categorie, id: v.id })
                  }
                })
                setCategory(check_list)
                setValue('Category', '')
                let s = document.getElementsByName('SubCategory')

                if (s.length > 0) {
                  s = s[0].getElementsByClassName('MuiAutocomplete-clearIndicator')
                  if (s.length > 0) {
                    s[0].click()
                  }
                }
                setValue('SubCategory', '')
                let v = document.getElementsByName('Category')

                if (v.length > 0) {
                  v = v[0].getElementsByClassName('MuiAutocomplete-clearIndicator')
                  if (v.length > 0) {
                    v[0].click()
                  }
                }
              }}
              label={t('finance.monBudget.columnClassification')}
              data={classification}
              name="Classification"
              required={true}
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Category', j)
                let check = []
                let check_list = []
                tempCategory.forEach((v) => {
                  if (j && v.Categorie === j.label && !check.includes(v.SousCategorie)) {
                    check.push(v.SousCategorie)
                    check_list.push({ label: v.SousCategorie, id: v.id })
                  }
                })
                setSubCategory(check_list)
                setValue('SubCategory', '')
                let s = document.getElementsByName('SubCategory')

                if (s.length > 0) {
                  s = s[0].getElementsByClassName('MuiAutocomplete-clearIndicator')
                  if (s.length > 0) {
                    s[0].click()
                  }
                }
              }}
              label={t('finance.monBudget.columnCategory')}
              data={Category}
              name="Category"
              required={true}
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('SubCategory', j)}
              label={t('finance.monBudget.columnSubCategory')}
              data={SubCategory}
              name="SubCategory"
              required={true}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Devise"
              label={t('finance.monBudget.columnCurrency')}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('finance.common.confirm')}</Button>
            <Button onClick={handleClose}>{t('finance.common.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
